PJQ.collections.reports = {};

PJQ.models.reports= {};

PJQ.views.reports = {};

PJQ.modules.reports = {
	routes: [
		{
			route: 'reports',
			name: 'reports',
			callback: function () {
				PJQ.app.initNavigator({
					activeItem: "reports"
				});
			}
		},
		{
			route: 'reportsadhoc',
			name: 'reportsadhoc',
			callback: function () {
				PJQ.app.initNavigator({
					activeItem: "reportsadhoc"
				});
			}
		}
	]
};
PJQ.app.addRoutes(PJQ.modules.reports.routes);